import { ScrollArea } from '@/components/ui/scroll-area';
import { FolderSelector } from '@/pages/Home/components/FolderSelector';
import { useLeftPanelDrawer } from '@/state/drawer-store';
import { cn } from '@/utils';

interface FolderSelectorCardProps {
  onSelect: () => void;
  setFolderName: (folderName: string) => void;
  setFolderId: (folderId?: number) => void;
  onClose?: () => void;
}

const FolderDialog = ({ onSelect, setFolderName, setFolderId, onClose }: FolderSelectorCardProps) => {
  const { setIsDrawerShow: setIsLeftPanelShow } = useLeftPanelDrawer();
  return (
    <div>
      <FolderSelector
        onCreateFolder={() => {
          setIsLeftPanelShow(true);
          onClose?.();
        }}
        onchange={(id, detail) => {
          const folderName = `${detail.fatherFolder?.name ?? ''}/${detail.name ?? ''}`;
          setFolderId(id);
          setFolderName(folderName);
        }}
      />
      <div
        onClick={() => {
          onSelect();
        }}
        className="border-jen-border border-t absolute left-0 bottom-0 p-jen-spacing-16 w-full cursor-pointer"
      >
        <div
          className={cn(
            'text-jen-content-primary-contrast text-[16px] rounded-jen-spacing-8 h-[40px] w-full flex justify-center items-center bg-jen-interactive-primary',
          )}
        >
          Select
        </div>
      </div>
    </div>
  );
};

export default FolderDialog;
